export default {
  code: 'ja',
  messages: {
    alpha: 'アルファベットのみ使用できます',
    alpha_num: '英数字のみ使用できます',
    alpha_dash: '英数字とハイフン、アンダースコアのみ使用できます',
    alpha_spaces: 'アルファベットと空白のみ使用できます',
    between: '{min}から{max}の間でなければなりません',
    confirmed: '{_field_}が一致しません',
    digits: '{length}桁の数字でなければなりません',
    dimensions: '幅{width}px、高さ{height}px以内でなければなりません',
    email: '★メールアドレスのフォーマットに誤りがあります',
    excluded: '不正な値です',
    ext: '有効なファイル形式ではありません',
    image: '有効な画像形式ではありません',
    integer: '整数のみ使用できます',
    is: '{_field_}が一致しません',
    length: '{length}文字でなければなりません',
    max_value: '{max}以下でなければなりません',
    max: '{length}文字以内にしてください',
    mimes: '有効なファイル形式ではありません',
    min_value: '{min}以上でなければなりません',
    min: '{length}文字以上で入力してください',
    numeric: '数字のみ使用できます',
    oneOf: '有効な値ではありません',
    regex: '{_field_}のフォーマットが正しくありません',
    required: '必須項目です',
    required_if: '必須項目です',
    size: '{size}KB以内でなければなりません',
  },
}



//////////////////
// WEBPACK FOOTER
// ./static/lang/vee-validate/ja.js
// module id = null
// module chunks = 